import { render, staticRenderFns } from "./TagSelect.vue?vue&type=template&id=232008c8&scoped=true"
import script from "./TagSelect.vue?vue&type=script&lang=js"
export * from "./TagSelect.vue?vue&type=script&lang=js"
import style0 from "./TagSelect.vue?vue&type=style&index=0&id=232008c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232008c8",
  null
  
)

export default component.exports